import Splide from '@splidejs/splide';

export class Slider {
    constructor(el) {
        this.splide = new Splide(el, {
            arrows: false,
            pagination: false,
            padding: {
                left: '7.6388888889vw',
                right: '15vw'
            },
            gap: (125*100/1440) + 'vw',
            breakpoints: {
                1024: {
                    padding: {
                        left: '5.3333333333vw',
                        right: '5.3333333333vw',
                    },
                    gap: '5.3333333333vw'
                }
            },
            speed: 1850
        })
        this.splide.on('mounted', () => {
            this._setupEvents()
            this._setActivePage()
        })
        this.splide.mount()

    }

    _setupEvents() {
        this.splide.on('moved', () => {
            this._setActivePage()
        })
        document.querySelectorAll('.paginator__page').forEach((page) => {
            page.addEventListener('click', (e) => {
                e.preventDefault()
                this.splide.go(page.dataset.page)
            })
        })
    }

    _setActivePage() {
        // console.log(this.splide.index)
        document.querySelectorAll('.paginator__page').forEach((page) => {
            page.classList.remove('active')
        })
        document.querySelector('.paginator__page[data-page="' + this.splide.index + '"]').classList.add('active')
    }
}
